export default __webpack_public_path__ + "static/media/res7.dd38cd3f.PNG";